<template>
    <div>
        <order-history msg="Order History" v-if="!showDetail"/>
        <order-detail v-if="showDetail" @view:detail="showOrderDetail()"/>
    </div>
</template>

<script>
// @ is an alias to /src
import OrderHistory from '@/components/OrderHistory.vue';
import OrderDetail from '@/components/OrderDetail.vue';

export default {
    name: 'orderView',
    components: {
        OrderHistory,
        OrderDetail
    },
    data() {
        return {
            showDetail: false
        };
    },
    mounted() {
        this.$root.$on('details:show', data => {
            this.showDetail = true;
        });
        this.$root.$on('details:hide', data => {
            this.showDetail = false;
        });
    },
    methods: {
        showOrderDetail() {
            this.showDetail = true;
        }
    }
};
</script>
